import React from 'react'
import { View, Separator, XStack, YStack, Text } from '@red-ui/components'
import { formatPoints } from '@vrw/data/src/utils/formatters'
import { getString } from '@vrw/data'
import { useSearchSummaryTexts } from '../../hooks/useSearchSummaryTexts'
import { CURRENCY_SYMBOLS, FarePriceCurrency } from '../../api/searchFlights'

type Props = {
  points: number
  fiatPrices: Record<FarePriceCurrency, number>
}

const PlusComponent = () => (
  <Text marginHorizontal="$4" fontWeight="700" fontSize="$7" $gtTabletLandscape={{ fontSize: '$9' }}>
    +
  </Text>
)

export const PointsSummary = ({ points, fiatPrices }: Props) => {
  const { passengers } = useSearchSummaryTexts()

  const currencyEntries = Object.entries(fiatPrices) as [FarePriceCurrency, number][]

  return (
    <View borderWidth={1} borderColor="$black2" borderRadius="$3" padding="$2">
      <XStack justifyContent="space-between" alignItems="flex-start">
        <Text fontSize="$4" $gtMobile={{ fontSize: '$5' }} $gtTabletLandscape={{ fontSize: '$6' }}>
          {getString('redSkySearch.results.sidesheet.summary.label')}
        </Text>
        <XStack marginLeft="$2">
          <YStack>
            <Text fontWeight="700" fontSize="$7" $gtTabletLandscape={{ fontSize: '$9' }}>
              {formatPoints({ points })}
            </Text>
            <Text>{getString('misc.virginPoints')}</Text>
          </YStack>
          <PlusComponent />
          {currencyEntries.map(([currency, value], index) => (
            <React.Fragment key={currency}>
              <YStack>
                <Text fontWeight="700" fontSize="$7" $gtTabletLandscape={{ fontSize: '$9' }}>
                  {CURRENCY_SYMBOLS[currency] ?? ''}
                  {value.toFixed(2)}
                  {CURRENCY_SYMBOLS[currency] ? '' : ` ${currency}`}
                </Text>
                <Text>{getString('redSkySearch.results.sidesheet.summary.fiat.name')}</Text>
              </YStack>
              {index < currencyEntries.length - 1 && <PlusComponent />}
            </React.Fragment>
          ))}
        </XStack>
      </XStack>
      <Separator marginVertical="$1" />
      <Text fontSize="$3" $gtTabletLandscape={{ fontSize: '$4' }} color="$black6">
        {getString('redSkySearch.results.sidesheet.summary.subtitle').replace('{{passengers}}', passengers)}
      </Text>
    </View>
  )
}
